/**
 * NotFound.tsx
 * ------------
 * 404 page for undefined routes.
 * - Multilingual error message and navigation back to home.
 */


import { useHistory } from 'react-router-dom';
import Button from './common/Button';
import { useProgress } from '../context/ProgressContext';

const NotFound = () => {
  const history = useHistory();
  const { language } = useProgress();
  const lang = (['en', 'fi', 'sv'].includes(language) ? language : 'fi') as 'en' | 'fi' | 'sv';

  const t = {
    notFound: {
      en: 'Page Not Found',
      fi: 'Sivua ei löytynyt',
      sv: 'Sidan hittades inte',
    },
    notFound404: {
      en: '404 - Page Not Found',
      fi: '404 - Sivua ei löytynyt',
      sv: '404 - Sidan hittades inte',
    },
    sorry: {
      en: 'Sorry, the page you are looking for does not exist.',
      fi: 'Valitettavasti etsimääsi sivua ei löytynyt.',
      sv: 'Sidan du letar efter finns tyvärr inte.',
    },
    backToLanding: {
      en: 'Back to Home',
      fi: 'Takaisin etusivulle',
      sv: 'Tillbaka till Hem',
    },
  };
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh]">
      <span className="text-7xl mb-4">🚫</span>
      <h1 className="text-3xl font-bold text-blue-900 mb-2">{t.notFound404[lang]}</h1>
      <p className="text-blue-800 mb-8 max-w-xs text-center">{t.sorry[lang]}</p>
      <Button gradient onClick={() => history.push('/')}>
        {t.backToLanding[lang]}
      </Button>
    </div>
  );
};
export default NotFound;
